import React from 'react';
import './App.css'
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import Aos from 'aos'
import 'aos/dist/aos.css'

Aos.init();

ReactDOM.render(
	<App />,
	document.getElementById('root')
)

reportWebVitals();
